import React, {FC, forwardRef} from 'react'
import {UseFormRegister, FieldErrors, useFormContext, Controller} from 'react-hook-form'

type InputProps = {
  name: string
  textPlaceholder: string
  register: UseFormRegister<any>
  errors: FieldErrors
  maxLength?: number
  minLength?: number
  caracteresTel?: boolean // Prop para habilitar o deshabilitar la validación de caracteres
  disabled?: boolean | undefined
  onChange?: (e: any) => void
  typeDoc?: any
  ref?: React.Ref<HTMLInputElement>
}

const InputNumberDocGet: FC<InputProps> = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      typeDoc = '',
      name,
      textPlaceholder,
      register,
      maxLength = 9999,
      minLength = 0,
      errors,
      disabled = false,
      caracteresTel = false,
      onChange,
      ...props
    },
    ref,
  ) => {
    const {control} = useFormContext()

    const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (typeDoc !== '00' && typeDoc !== '07') {
        let regex = caracteresTel ? /^[\d+\-()]*$/ : /^\d$/
        if (!regex.test(e.key) && e.keyCode !== 8) {
          e.preventDefault()
        }
      }
    }

    return (
      <div className='sdx_form_input'>
        <Controller
          name={name} // Nombre del campo en el formulario y debe coincidir con el nombre en el esquema de validación
          control={control} // Proporciona el objeto 'control' de react-hook-form
          render={({field}) => (
            <input
              {...field}
              ref={ref}
              type='text'
              className='form-control sdx-centra-input-form'
              placeholder={textPlaceholder}
              maxLength={maxLength}
              onKeyPress={handleKeyPress}
              disabled={disabled}
            />
          )}
        />

        {errors[name] && <p>{errors[name]?.message?.toString()}</p>}
      </div>
    )
  },
)
export default InputNumberDocGet
